import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { FormService } from '../../services/form.service';
import { DescriptorFormControl } from '../../descriptor';

@Component({
  selector: 'vedrax-table-filter',
  templateUrl: './vedrax-table-filter.component.html'
})
export class VedraxTableFilterComponent implements OnInit {

  /**
   * The list of filter controls
   */
  @Input() filters: DescriptorFormControl[] = [];

  /**
   * Status of the request
   */
  @Input() submitted: boolean = false;

  /**
   * Emit event with data when submitting the form
   */
  @Output() onSubmit = new EventEmitter<any>();

  /**
   * The form object
   */
  formSearch: FormGroup = new FormGroup({});

  constructor(
    private formService: FormService
  ) { }

  ngOnInit() {
    //init attributes
    if (!this.filters) {
      this.filters = [];
    }
    if (!this.submitted) {
      this.submitted = false;
    }
    this.formSearch = this.formService.createFormGroup(this.filters);
  }

  /**
   * Emit an event with data when the form is valid
   * 
   * @param dto 
   */
  submit(dto: any): void {
    if (this.formSearch.valid) {
      this.submitted = true;
      this.onSubmit.emit(dto);
    }
  }

  /**
   * The reset form method
   */
  reset(): void {
    this.formSearch.reset();
  }

}
